import listExamModulesDoc from '../../api/examModules/listExamModulesDoc';
import {getCurrentUser, getCurrentUserRoles} from '../../config/firebaseUser';
import {useFunctionList} from '../helper/function/useFunctionList';

/**
 * List exam modules from Firestore. Access is enforced by rules: only public modules
 * (requiredRole empty) or modules whose requiredRole matches the user's roles are returned.
 */
export default function useListExamModules() {
  const {data, loading, error} = useFunctionList(async () => {
    const user = getCurrentUser();
    if (!user) return [];
    const roles = await getCurrentUserRoles();
    return listExamModulesDoc(roles);
  });

  return {
    examModules: data ?? [],
    loading,
    error,
  };
}
